import AEText from './APText';

export {
  AEText
};

export default AEText;